export const RETRIEVE_EXTRAS_MARKETPLACE = 'extras/retrieve/marketplace';
export const RETRIEVE_EXTRAS_TAKEN = 'extras/retrieve/taken';
export const RETRIEVE_EXTRAS_STATISTICS = 'extras/retrieve/statistics';
